import React from 'react';
import {
  RatingConfigurator,
  SingleSelectionConfigurator,
  CommentConfigurator,
  EmailConfigurator,
  SurveyFactory,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const recommendationSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'AdInsightRecommendationSurvey',
    style: {
      root: {
        maxWidth: 480,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with Microsoft Advertising\'s Recommendations page?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neither satisfied nor dissatisfied')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      isRequired: true,
      Type: EmailConfigurator,
      key: 'email',
      page: 4,
      position: 1,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: answers => ['5', '4', '3', '2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
    questions: [
      {
        Type: CommentConfigurator,
        key: 'q1',
        page: 1,
        position: 0,
        getTitle: (answers, surveyConfigurator) => {
          const questionConfigurator = surveyConfigurator.getQuestionByKey('rating');
          const optionKey = answers.rating.selectedOption;
          // option to text
          return i18n.getString(
            _TL_('Can you tell us more about where you are {{option}} with Microsoft Adertising\'s Recommendations?'),
            { option: questionConfigurator.optionKeyToText[optionKey].toLowerCase() }
          );
        },
        data: {
        },
      },
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q2',
        page: 2,
        position: 0,
        getTitle: () => i18n.getString(_TL_('How often do you check out Recommendations page?')),
        options: [
          {
            key: 'q2o1',
            text: i18n.getString(_TL_('Once every 2-3 months')),
          },
          {
            key: 'q2o2',
            text: i18n.getString(_TL_('Once per month')),
          },
          {
            key: 'q2o3',
            text: i18n.getString(_TL_('2-3 times per month')),
          },
          {
            key: 'q2o4',
            text: i18n.getString(_TL_('Once per week')),
          },
          {
            key: 'q2o5',
            text: i18n.getString(_TL_('2-3 times per week')),
          },
          {
            key: 'q2o6',
            text: i18n.getString(_TL_('Everyday')),
          },
          {
            key: 'q2o7',
            text: i18n.getString(_TL_('Others')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q3',
        page: 3,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Is Optimization Score helpful when you act on Recommendations?')),
        options: [
          {
            key: 'q3o1',
            text: i18n.getString(_TL_('Very helpful')),
          },
          {
            key: 'q3o2',
            text: i18n.getString(_TL_('Moderately helpful')),
          },
          {
            key: 'q3o3',
            text: i18n.getString(_TL_('Neither helpful nor unhelpful')),
          },
          {
            key: 'q3o4',
            text: i18n.getString(_TL_('Somewhat unhelpful')),
          },
          {
            key: 'q3o5',
            text: i18n.getString(_TL_('Not at helpful')),
          },
        ],
      },
      {
        Type: CommentConfigurator,
        key: 'q4',
        page: 4,
        position: 0,
        getTitle: () => i18n.getString(_TL_('If you could change one thing to improve Optimization Score, what would it be?')),
        data: {
        },
      },
    ],
  };
};

export const FactorySurveyView = props => (
  <SurveyFactory
    getSurveyConfiguration={recommendationSurveyConfig}
    {...props}
  />);
